import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const subejctKey = 'user-subject'
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
/**
 * 用户信息存储
 * @param {} subjectName 
 * @returns 
 */
export function setSubejct(subjectName){
  return Cookies.set(subejctKey, subjectName)
}
export function getSubejct(){
  return Cookies.get(subejctKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js